module.exports = __webpack_public_path__ + "media/state-press_2000.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/state-press_2000.jpg
// module id = 50
// module chunks = 0